import { Report55Container } from "../../../containers/SupportSystem/Reports/Report55Container";
export function Report55Page() {
    return (
        <Report55Container />
    );

}